import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import type { MatchParticipantExtension as MatchParticipantModel } from 'tio-data/data/resources/match-participant.ext';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';

export interface AuthenticatedSyfRouteModel {
  matchParticipant: MatchParticipantModel;
}

export default class AuthenticatedSyfRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  async model(): Promise<AuthenticatedSyfRouteModel | null> {
    // Guard the whole lookup: users without an employee record (or whose
    // match-participant includes 403) previously threw out of model(),
    // stranding the transition on /syf with a blank screen. A null model
    // exits the SYF tree (child routes redirect to authenticated.dashboard).
    const employeeId = this.sessionContext.currentEmployee?.id;
    if (!employeeId) {
      return null;
    }

    try {
      const { content } = (await this.store.request(
        findRecord<EmployeeModel>('employee', employeeId, {
          include: [
            'match-participant.email-address',
            'match-participant.match-plan',
            'match-participant.person',
          ].join(','),
          reload: true,
        })
      )) as { content: { data: EmployeeModel } };
      const employee = content.data;

      const matchParticipant = employee.matchParticipant;
      if (!matchParticipant) {
        return null;
      }

      return {
        matchParticipant,
      };
    } catch (e) {
      console.error('Failed to load SYF match participant:', e);
      return null;
    }
  }
}
